import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".shipping-dialog-footer{flex-direction:row!important;justify-content:space-between!important}.shipping-dialog-footer .shipping-dialog-footer-button{width:164px!important}.shipping-address-container{border:1px solid var(--swan-sem-color-border-standard);border-radius:var(--swan-sem-border-radius-container);max-width:664px;width:100%}.shipping-address-form-container .form-field-container{margin-top:var(--swan-sem-space-6)!important}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
